/* BUG-019/020-Aufräumung: Der frühere "ensureConfigAndFallback"-Watchdog wurde
   entfernt. Er lud (1) den toten Config-Endpoint ?vitalshop_sc_cfg=1 (Handler
   liegt im stillgelegten smart-checkout-logic.php → lieferte eine HTML-Seite
   als "Script") und (2) smart-checkout-fallback.js vom HARTKODIERT FALSCHEN
   Theme-Pfad /themes/vitalshop/ (existiert nur als Altlast auf Staging — dort
   lief dadurch ein uraltes Checkout-Script zusätzlich). Config kommt via
   wp_localize_script, das Fallback-Script enqueued das Checkout-Template. */
jQuery(document).ready(function($) {
    var vsI18n = (window.vitalshop_smart_checkout && window.vitalshop_smart_checkout.strings) || {};
    function t(key, fallback){ try { return (vsI18n && vsI18n[key]) ? vsI18n[key] : fallback; } catch(_) { return fallback; } }
    // ==== Floating-Label Aktivierung für Textfelder (inkl. Adresse 1/2) ====
    function refreshFloatingLabels(){
        $('.vitalshop-modern-checkout .form-row').each(function(){
            var $row = $(this);
            var $input = $row.find('input[type="text"], input[type="email"], input[type="tel"], textarea');
            var $label = $row.find('label');
            if ($input.length && $label.length) {
                // Label in den Wrapper verschieben, damit es über dem Feld liegt (wie bei Country)
                var $wrapper = $row.find('.woocommerce-input-wrapper');
                if ($wrapper.length && !$wrapper.find('label').length) {
                    $wrapper.append($label);
                }
                $label.addClass('floating-label').removeClass('screen-reader-text');
                // Stelle sicher, dass das Eingabefeld die Klasse für Placeholder-Handling hat
                $input.addClass('floating-label-input');
                if (($input.val()||'').trim() !== '') { $label.addClass('active'); $row.addClass('has-value'); } else { $label.removeClass('active'); $row.removeClass('has-value'); }
                // Placeholder-Original speichern
                if (typeof $input.data('ph') === 'undefined') { $input.data('ph', $input.attr('placeholder') || ''); }
                $input.off('focus.floating blur.floating input.floating').on('focus.floating', function(){
                    $label.addClass('active'); $row.addClass('has-value');
                    $(this).attr('placeholder','');
                }).on('blur.floating', function(){
                    if (($(this).val()||'').trim() === '') { $label.removeClass('active'); $row.removeClass('has-value'); $(this).attr('placeholder', $(this).data('ph') || ''); }
                }).on('input.floating', function(){
                    if (($(this).val()||'').trim() !== '') { $label.addClass('active'); $row.addClass('has-value'); $(this).attr('placeholder',''); } else { $label.removeClass('active'); $row.removeClass('has-value'); $(this).attr('placeholder', $(this).data('ph') || ''); }
                });
                
            } else if ($input.length && !$label.length) {
                // Kein Label vorhanden (kommt bei address_1/_2 vor) → dynamisch erzeugen aus Placeholder/Data-Label
                var $wrapper2 = $row.find('.woocommerce-input-wrapper');
                var $inputEl = $input.first();
                var id = $inputEl.attr('id') || '';
                var explicitMap = {
                    'billing_address_1': 'Straße und Hausnummer',
                    'billing_address_2': 'Apartment, Haus, etc. (optional)'
                };
                var labelText = explicitMap[id] || ($inputEl.attr('data-label') || $row.attr('data-label') || $inputEl.attr('placeholder') || '').trim();
                if (!labelText) { labelText = ($inputEl.attr('id')||'').replace(/_/g,' '); }
                if ($wrapper2.length) {
                    var $dyn = $('<label/>', { 'class': 'floating-label', 'for': $inputEl.attr('id') }).text(labelText);
                    $wrapper2.append($dyn);
                    $inputEl.addClass('floating-label-input');
                    // Placeholder-Original speichern
                    if (typeof $inputEl.data('ph') === 'undefined') { $inputEl.data('ph', $inputEl.attr('placeholder') || ''); }
                    // Aktivzustand setzen
                    if (($inputEl.val()||'').trim() !== '') { $dyn.addClass('active'); $row.addClass('has-value'); $inputEl.attr('placeholder',''); }
                    $inputEl.off('focus.floatingAddr blur.floatingAddr input.floatingAddr')
                        .on('focus.floatingAddr', function(){
                            $dyn.addClass('active'); $row.addClass('has-value'); $(this).attr('placeholder','');
                        }).on('blur.floatingAddr', function(){
                            if (($(this).val()||'').trim() === '') { $dyn.removeClass('active'); $row.removeClass('has-value'); $(this).attr('placeholder', $(this).data('ph') || ''); }
                        }).on('input.floatingAddr', function(){
                            if (($(this).val()||'').trim() !== '') { $dyn.addClass('active'); $row.addClass('has-value'); $(this).attr('placeholder',''); } else { $dyn.removeClass('active'); $row.removeClass('has-value'); $(this).attr('placeholder', $(this).data('ph') || ''); }
                        });
                    
                }
            }
        });
    }

    // Erzwinge aktiven Floating-Status für programmatisch gefüllte Felder
    function forceFloatingForFilledIds(ids){
        ids.forEach(function(id){
            var $f = $('#'+id);
            if (!$f.length) return;
            var $row = $f.closest('.form-row');
            var $wrapper = $row.find('.woocommerce-input-wrapper');
            var $lbl = $wrapper.find('label.floating-label');
            if (!$lbl.length) {
                // Versuche vorhandenes Label in den Wrapper zu verschieben
                var $existing = $row.find('> label');
                if ($existing.length) {
                    if ($wrapper.length) { $wrapper.append($existing); $lbl = $existing; }
                } else if ($wrapper.length) {
                    // Dynamisch erzeugen aus Placeholder/Data-Label
                    var txt = ($f.attr('data-label') || $row.attr('data-label') || $f.attr('placeholder') || '').trim();
                    if (!txt) { txt = (id === 'billing_city') ? 'Ort' : (id === 'billing_postcode' ? 'PLZ' : id.replace(/_/g,' ')); }
                    $lbl = $('<label/>', { 'class':'floating-label', 'for': id }).text(txt);
                    $wrapper.append($lbl);
                }
            }
            if ($lbl && $lbl.length) { $lbl.addClass('floating-label').removeClass('screen-reader-text'); }
            $f.addClass('floating-label-input');
            if (($f.val()||'').trim() !== '') { if ($lbl && $lbl.length) { $lbl.addClass('active'); } $row.addClass('has-value'); }
            else { if ($lbl && $lbl.length) { $lbl.removeClass('active'); } $row.removeClass('has-value'); }
        });
    }
    // Aggressiver Spezial-Init für Address 1/2
    function ensureAddressFloatingLabels(){
        ['billing_address_1','billing_address_2'].forEach(function(id){
            var $row = $('#'+id+'_field');
            if (!$row.length) return;
            var $wrapper = $row.find('.woocommerce-input-wrapper');
            var $input = $('#'+id);
            if (!$input.length || !$wrapper.length) return;
            var $label = $wrapper.find('label');
            if (!$label.length) {
                var explicitMap = {
                    'billing_address_1': 'Straße und Hausnummer',
                    'billing_address_2': 'Apartment, Haus, etc. (optional)'
                };
                var labelText = explicitMap[id] || ($input.attr('data-label') || $row.attr('data-label') || $input.attr('placeholder') || '').trim();
                if (!labelText) { labelText = (id === 'billing_address_1') ? 'Straße und Hausnummer' : 'Apartment, Haus, etc. (optional)'; }
                $label = $('<label/>', { 'class':'floating-label', 'for': id }).text(labelText);
                $wrapper.append($label);
            } else {
                // Falls ein bestehendes Label nur "Straße" enthält → auf unseren Text anheben, Required-Abzeichen beibehalten
                try {
                    var labelId = id;
                    var desired = (labelId === 'billing_address_1') ? 'Straße und Hausnummer' : (labelId === 'billing_address_2' ? 'Apartment, Haus, etc. (optional)' : null);
                    if (desired) {
                        var $req = $label.find('.required, abbr.required').first();
                        var reqHtml = $req.length ? $req.prop('outerHTML') : '';
                        if (($label.text() || '').trim() !== desired) {
                            $label.html(desired + (reqHtml ? ' ' + reqHtml : ''));
                        }
                        if (!$label.hasClass('required_field') && $req.length) { $label.addClass('required_field'); }
                    }
                    $label.removeClass('screen-reader-text');
                } catch(__) {}
            }
            $input.addClass('floating-label-input');
            if (($input.val()||'').trim() !== '') { $label.addClass('active'); $row.addClass('has-value'); } else { $label.removeClass('active'); $row.removeClass('has-value'); }
            $input.off('focus.floatingAddr blur.floatingAddr input.floatingAddr')
                .on('focus.floatingAddr', function(){ $label.addClass('active'); $row.addClass('has-value'); })
                .on('blur.floatingAddr', function(){ if (($(this).val()||'').trim() === '') { $label.removeClass('active'); $row.removeClass('has-value'); } })
                .on('input.floatingAddr', function(){ if (($(this).val()||'').trim() !== '') { $label.addClass('active'); $row.addClass('has-value'); } else { $label.removeClass('active'); $row.removeClass('has-value'); } });
            
        });
    }
    refreshFloatingLabels();
    ensureAddressFloatingLabels();
    $(document.body).on('updated_checkout', function(){ setTimeout(refreshFloatingLabels, 100); });
    $(document.body).on('updated_checkout', function(){ setTimeout(ensureAddressFloatingLabels, 120); });
    // Wiederholte kurze Versuche (falls DOM später ersetzt wird)
    setTimeout(ensureAddressFloatingLabels, 300);
    setTimeout(ensureAddressFloatingLabels, 800);
    setTimeout(ensureAddressFloatingLabels, 1500);
    // Spezieller Retry für Address 2, bis Label existiert oder Max-Tries erreicht
    try {
        if (!window.__vs_addr2_interval) {
            var tries = 0;
            window.__vs_addr2_interval = setInterval(function(){
                try {
                    ensureAddressFloatingLabels();
                    var ok = $('#billing_address_2_field .floating-label').length > 0;
                    tries++;
                    if (ok || tries > 20) { clearInterval(window.__vs_addr2_interval); window.__vs_addr2_interval = null; }
                } catch(__) { tries++; if (tries>20){ clearInterval(window.__vs_addr2_interval); window.__vs_addr2_interval=null; } }
            }, 200);
        }
    } catch(__){}

    // Reagiere auf Change-Ereignisse (auch programmatic) und erzwinge Floating
    $(document).on('change', '#billing_postcode, #billing_city, #billing_address_1, #billing_address_2', function(){
        forceFloatingForFilledIds(['billing_postcode','billing_city','billing_address_1','billing_address_2']);
        // Nach programmatic Set erneut Labels sichern
        setTimeout(function(){ forceFloatingForFilledIds(['billing_postcode','billing_city']); }, 30);
    });
    $(document.body).on('updated_checkout', function(){ setTimeout(function(){ forceFloatingForFilledIds(['billing_postcode','billing_city','billing_address_1','billing_address_2']); }, 60); });

    // Extra: Sofortiges Erzwingen für Stadt, wenn Autocomplete diese setzt
    try {
        var cityEl = document.getElementById('billing_city');
        if (cityEl && !cityEl.__fl_watch){
            cityEl.__fl_watch = true;
            var prevCity = cityEl.value;
            setInterval(function(){
                try {
                    if (cityEl.value !== prevCity){ prevCity = cityEl.value; forceFloatingForFilledIds(['billing_city']); }
                } catch(_){ }
            }, 200);
        }
    } catch(__){}

    // Beobachte Value-Änderungen durch Autocomplete (Interval)
    try {
        var targets = ['billing_postcode','billing_city','billing_address_1','billing_address_2'];
        targets.forEach(function(id){
            var el = document.getElementById(id); if (!el) return;
            var prev = el.value;
            setInterval(function(){
                try { if (el.value !== prev){ prev = el.value; forceFloatingForFilledIds([id]); } } catch(_){}
            }, 250);
        });
    } catch(_){}

    // Falls Adress-Autocomplete das Feld ersetzt: neu initialisieren wenn der Dropdown wrapper erscheint/verschwindet
    const observer = new MutationObserver(function(mutations){
        var needsRefresh = false;
        mutations.forEach(function(m){
            if (m.addedNodes && m.addedNodes.length) {
                var $nodes = $(m.addedNodes);
                if ($nodes.find('#billing_address_autocomplete').length || $nodes.closest('#billing_address_autocomplete').length) { needsRefresh = true; }
                if ($nodes.find('#billing_address_1, #billing_address_2').length || $nodes.filter('#billing_address_1, #billing_address_2').length) { needsRefresh = true; }
                if ($nodes.find('#billing_address_1_field, #billing_address_2_field').length || $nodes.filter('#billing_address_1_field, #billing_address_2_field').length) { needsRefresh = true; }
            }
        });
        if (needsRefresh) { setTimeout(function(){ refreshFloatingLabels(); ensureAddressFloatingLabels(); }, 50); }
    });
    try { observer.observe(document.body, {childList:true, subtree:true}); } catch(_){ }

    // === States mit Land synchronisieren (WC Mapping nutzen) ===
    function syncStateFieldWithCountry(countryCode){
        try {
            countryCode = String(countryCode||'').toUpperCase();
            var wcParams = window.wc_country_select_params || {};
            var wcAll = wcParams.countries || wcParams.states || {};
            var wcForCountry = wcAll && wcAll[countryCode] ? wcAll[countryCode] : null;
            var vsAll = (window.vs_country_locale && window.vs_country_locale.states) ? window.vs_country_locale.states : {};
            var vsForCountry = vsAll && vsAll[countryCode] ? vsAll[countryCode] : null;
            var states = wcForCountry && Object.keys(wcForCountry).length ? wcForCountry : (vsForCountry && Object.keys(vsForCountry).length ? vsForCountry : null);
            var $state = $('#billing_state'); if (!$state.length) return;
            if ($state.is('select')){
                var current = $state.val();
                $state.empty();
                $state.append($('<option>', { value: '' }).text(''));
                if (states && Object.keys(states).length){
                    Object.keys(states).forEach(function(code){ $state.append($('<option>', { value: code }).text(states[code])); });
                    $state.prop('disabled', false).show();
                } else {
                    $state.prop('disabled', false).show();
                }
                if (current && $state.find('option[value="'+current+'"]').length){ $state.val(current); }
                else { $state.val(''); }
                // Select2/SelectWoo neu initialisieren, damit die Anzeige die neuen Optionen übernimmt
                try {
                    if ($state.data('select2') || $state.hasClass('select2-hidden-accessible')) {
                        if (typeof $state.selectWoo === 'function') { try { $state.selectWoo('destroy'); } catch(_){} try { $state.selectWoo(); } catch(_){} }
                        else if (typeof $state.select2 === 'function') { try { $state.select2('destroy'); } catch(_){} try { $state.select2(); } catch(_){} }
                    }
                    $(document.body).trigger('wc-enhanced-select-init');
                } catch(__){}
                $state.trigger('change');
            } else {
                $state.attr('placeholder', t('state_placeholder','Region / Bundesland'));
                forceFloatingForFilledIds(['billing_state']);
            }
        } catch(__){}
    }
    window.syncStateFieldWithCountry = syncStateFieldWithCountry;
    // Nach Reload ggf. Reload-Flag zurücksetzen
    try {
        if (sessionStorage.getItem('vs_country_reloading') === '1') {
            sessionStorage.removeItem('vs_country_reloading');
            try {
                var code = ($('#billing_country').val() || $('input[name="billing_country"]').val() || '').toString();
                if (code) {
                    var $orig = $('select#billing_country');
                    var name = '';
                    if ($orig.length) { name = $orig.find('option[value="'+code+'"]').text() || ''; }
                    if (!name && window.wc_country_select_params && wc_country_select_params.countries) {
                        name = wc_country_select_params.countries[code] || '';
                    }
                    var $disp = jQuery('#billing_country_display');
                    if ($disp.length && name) { $disp.val(name); $disp.closest('.country-autocomplete-wrapper').find('.floating-label').addClass('active'); }
                }
            } catch(__){}
             // Nach Reload Checkout-Daten aktualisieren
            setTimeout(function(){
                try { jQuery(document.body).trigger('update_checkout'); } catch(_){}
                setTimeout(function(){ try { jQuery(document.body).trigger('wc_fragment_refresh'); } catch(__){} }, 150);
            }, 150);
        }
    } catch(_){ }
    // One Address System: sync shipping_country from billing_country, then let WooCommerce's
    // native update_checkout handle the AJAX refresh (no separate force_wc_session_update + reload)
    function onBillingCountryChange(el) {
        var c = (($(el).val() || '').toUpperCase());
        syncStateFieldWithCountry(c);
        setTimeout(toggleStateVisibility, 0);
        try { $('#shipping_country').val(c); } catch(_){ }
        try { $('input[name="shipping_country"]').val(c); } catch(_){ }
        try { sessionStorage.setItem('vs_billing_country', c); sessionStorage.setItem('vs_shipping_country', c); } catch(_){ }
        jQuery(document.body).trigger('update_checkout');
    }
    $(document).on('change', '#billing_country', function(){ onBillingCountryChange(this); });
    $(document).on('change', 'input[name="billing_country"]', function(){ onBillingCountryChange(this); });

    // Initiale Synchronisierung beim Laden
    try {
        var initialCountry = ($('#billing_country').val()||$('input[name="billing_country"]').val()||'').toUpperCase();
        if (initialCountry) { syncStateFieldWithCountry(initialCountry); }
    } catch(__){}

    // Wiederholte kurze Versuche, falls WC-Params/DOM verspätet da sind
    (function(){
        try {
            var tries = 0; var lim = 10;
            var iv = setInterval(function(){
                try {
                    var c = ($('#billing_country').val()||$('input[name="billing_country"]').val()||'').toUpperCase();
                    if (c) { syncStateFieldWithCountry(c); }
                    tries++;
                    if (tries >= lim) { clearInterval(iv); }
                } catch(_){ tries++; if (tries>=lim) { clearInterval(iv); } }
            }, 250);
        } catch(_){ }
    })();
    // ==== Clientseitige Pflichtfeld-Prüfung vor Submit ====
    function markFieldError($input, msg){
        var $row = $input.closest('.form-row');
        if ($row.length === 0) { $row = $input.parent(); }
        $row.addClass('field-error');
        if ($row.find('.field-error-msg').length === 0) {
            $('<small class="field-error-msg"></small>').text(msg).appendTo($row);
        } else {
            $row.find('.field-error-msg').text(msg).show();
        }
    }
    function clearFieldError($input){
        var $row = $input.closest('.form-row');
        if ($row.length === 0) { $row = $input.parent(); }
        $row.removeClass('field-error');
        $row.find('.field-error-msg').remove();
    }
    function validateRequiredFields(){
        var requiredIds = [
            'billing_first_name','billing_last_name','billing_address_1',
            'billing_postcode','billing_city','billing_email','billing_phone'
        ];
        var ok = true;
        requiredIds.forEach(function(id){
            var $f = $('#'+id);
            if (!$f.length) return;
            clearFieldError($f);
            var val = ($f.val()||'').trim();
            if (!val) {
                ok = false;
                markFieldError($f, t('required_field','Pflichtfeld'));
                return;
            }
            if (id === 'billing_email'){
                var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!re.test(val.toLowerCase())) { ok=false; markFieldError($f, t('email_invalid','Bitte gebe eine gültige E-Mail-Adresse ein')); }
            }
            if (id === 'billing_phone'){
                // einfache Phone-Prüfung: mind. 6 Ziffern
                var digits = (val.match(/\d/g)||[]).length;
                if (digits < 6) { ok=false; markFieldError($f, t('phone_invalid','Bitte eine gültige Telefonnummer angeben')); }
            }
        });
        return ok;
    }

    // Beim Klick auf Bestellen prüfen; bei Fehlern Submit verhindern
    $(document).on('click', '#place_order', function(e){
        var ok = validateRequiredFields();
        if (!ok) {
            try { e.preventDefault(); e.stopPropagation(); } catch(_){ }
            // zum ersten Fehler scrollen
            var $first = $('.form-row.field-error').first();
            if ($first.length){ $('html, body').animate({scrollTop: $first.offset().top - 80}, 250); }
            return false;
        }
        return true;
    });

    // === Email Blur-Validierung ===
    function isValidEmail(email){
        // einfache, robuste E-Mail-Validierung (keine exotischen TLD-Annahmen)
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return re.test(String(email).toLowerCase());
    }

    function showFieldError($input, message){
        var $row = $input.closest('.form-row');
        if ($row.length === 0) { $row = $input.parent(); }
        $row.addClass('field-error');
        if ($row.find('.field-error-msg').length === 0) {
            $('<small class="field-error-msg"></small>').text(message).appendTo($row);
        } else {
            $row.find('.field-error-msg').text(message).show();
        }
    }

    function clearFieldError($input){
        var $row = $input.closest('.form-row');
        if ($row.length === 0) { $row = $input.parent(); }
        $row.removeClass('field-error');
        $row.find('.field-error-msg').remove();
    }

    $(document).on('blur', '#billing_email', function(){
        var $el = $(this);
        var val = ($el.val() || '').trim();
        if (!val) { clearFieldError($el); return; }
        if (!isValidEmail(val)) {
            showFieldError($el, t('email_invalid','Bitte gebe eine gültige E-Mail-Adresse ein'));
        } else {
            clearFieldError($el);
        }
    });

    
    
    // CRITICAL: Auto-load address on page load
    // MUST run after DOM is fully ready and address radios are rendered
    $(document).ready(function() {
        // Wait a bit to ensure address selection HTML is rendered
        setTimeout(function() {
            // console.log('🔍 Trying to find address radios...');
            
            // Check which address is currently selected (either from localStorage or pre-checked in HTML)
            var $checkedRadio = $('input[name="selected_address"]:checked');
            
            // console.log('🔍 Checkout Page Load - Address Check:', {
            //     checkedRadioFound: $checkedRadio.length > 0,
            //     checkedValue: $checkedRadio.length > 0 ? $checkedRadio.val() : null,
            //     allRadios: $('input[name="selected_address"]').length
            // });
            
            if ($checkedRadio.length > 0) {
                var checkedValue = $checkedRadio.val();
                
                // console.log('✅ Found checked address:', checkedValue);
                
                // Save to localStorage for next time
                try { 
                    localStorage.setItem('vitalshop_selected_address', checkedValue); 
                } catch(__) {}
                
                // IMPORTANT: Actually load the address data
                if (checkedValue !== 'new') {
                    // console.log('🚀 Loading address via AJAX:', checkedValue);
                    // Load the address via AJAX (same as when user clicks)
                    loadSavedAddress(checkedValue);
                }
            } else {
                // console.log('⚠️ No checked radio found, checking localStorage...');
                // Fallback: Check localStorage
                var savedAddressId = localStorage.getItem('vitalshop_selected_address');
                if (savedAddressId) {
                    // console.log('📦 Found savedAddressId in localStorage:', savedAddressId);
                    var $targetRadio = $('input[name="selected_address"][value="' + savedAddressId + '"]');
                    if ($targetRadio.length > 0) {
                        // console.log('✅ Radio button found, checking it...');
                        $targetRadio.prop('checked', true);
                        // Load the address
                        if (savedAddressId !== 'new') {
                            // console.log('🚀 Loading address via AJAX:', savedAddressId);
                            loadSavedAddress(savedAddressId);
                        }
                    } else {
                        // console.log('❌ Radio button not found for:', savedAddressId);
                        // Clear invalid saved address
                        localStorage.removeItem('vitalshop_selected_address');
                    }
                } else {
                    // console.log('❌ No savedAddressId in localStorage');
                }
            }
        }, 500); // Wait 500ms for DOM to be fully ready
    });
    
    // Handle address selection
    $(document).on('change', 'input[name="selected_address"]', function() {
        var selectedValue = $(this).val();
        var $smartSelection = $('.smart-address-selection');
        var $customerDetails = $('.customer-details-section');
        
        
        // CRITICAL: Save selected address to localStorage for persistence
        localStorage.setItem('vitalshop_selected_address', selectedValue);
        
        if (selectedValue === 'new') {
            // Show manual entry form
            $smartSelection.removeClass('active').addClass('manual-entry');
            $customerDetails.find('.billing-fields').show();
            
            // Clear all billing fields (One Address System)
            clearBillingFields();
            
        } else {
            // Load saved address
            $smartSelection.removeClass('manual-entry').addClass('active');
            $customerDetails.find('.billing-fields').hide();
            
            // Load address data via AJAX
            loadSavedAddress(selectedValue);
        }
        
        // Update hidden field
        $('#selected_address_id').val(selectedValue);
        
        // Update visual selection
        updateAddressCardSelection($(this));
        
        // Trigger order review update for shipping calculation
        if (selectedValue !== 'new') {
            
            triggerOrderReviewUpdate(selectedValue);
        }
        // Always trigger a checkout update as a fallback
        setTimeout(function(){ $(document.body).trigger('update_checkout'); }, 50);
    });
    
    // ==== Bundesland/Region gemäß Woo-Locale (nur wenn Pflicht) anzeigen ====
    function toggleStateVisibility(){
        try {
            var country = ($('#billing_country').val()||'').toUpperCase();
            // WooCommerce-Locale auswerten → robust gemäß Core-Definitionen (mit Fallback)
            var locale = (window.wc_address_i18n_params && window.wc_address_i18n_params.locale)
                ? window.wc_address_i18n_params.locale
                : (window.vs_country_locale && window.vs_country_locale.locale ? window.vs_country_locale.locale : {});
            var stateCfg = (locale[country] && locale[country].state) ? locale[country].state : {};
            var isRequired = !!stateCfg.required;
            // Fallback: Falls Locale fehlt/leer, nutze bekannte Länderliste
            if (!isRequired && (!locale || !locale[country])) {
                var fallbackRequired = ['US','CA','AU','CN','BR','MX','MY','NZ','KR','IT'];
                if (fallbackRequired.indexOf(country) !== -1) { isRequired = true; }
            }
            var show = isRequired; // nur anzeigen, wenn Pflicht
            var $state = $('#billing_state');
            var $row = $('#billing_state_field'); if (!$row.length) { $row = $state.closest('.form-row'); }
            if (!$row.length) return;

            // Optionen passend zum Land setzen (auch wenn nicht sichtbar, damit beim späteren Required die Liste korrekt ist)
            try { if (typeof syncStateFieldWithCountry === 'function') { syncStateFieldWithCountry(country); } } catch(__){}

            if (show) {
                $row.show();
                $state.prop('required', !!isRequired);
                if (isRequired) { $state.attr('aria-required','true'); } else { $state.removeAttr('aria-required'); }
                // Select2/SelectWoo sicher neu initialisieren
                try {
                    if ($state.data('select2') || $state.hasClass('select2-hidden-accessible')) {
                        if (typeof $state.selectWoo === 'function') { try { $state.selectWoo('destroy'); } catch(_){} try { $state.selectWoo(); } catch(_){} }
                        else if (typeof $state.select2 === 'function') { try { $state.select2('destroy'); } catch(_){} try { $state.select2(); } catch(_){} }
                    }
                    $(document.body).trigger('wc-enhanced-select-init');
                } catch(__){}
            } else {
                $state.prop('required', false).removeAttr('aria-required').val('');
                $row.hide();
                // Bei Ausblendung UI sauber zurücksetzen
                try {
                    if ($state.data('select2') || $state.hasClass('select2-hidden-accessible')) {
                        if (typeof $state.selectWoo === 'function') { try { $state.selectWoo('destroy'); } catch(_){} }
                        else if (typeof $state.select2 === 'function') { try { $state.select2('destroy'); } catch(_){} }
                    }
                } catch(__){}
            }
        } catch(__){}
    }
    // Global export für externe Trigger (Country-Autocomplete)
    try { window.toggleStateVisibility = toggleStateVisibility; } catch(_e){}

    // Zusätzliche Listener: Hidden-Input vom Country-Autocomplete und WC-Events
    $(document).on('change', 'input[name="billing_country"]', toggleStateVisibility);
    $(document).on('updated_checkout', function(){ setTimeout(toggleStateVisibility, 60); });
    // Wiederholt initial versuchen (DOM/WC-Params latenzen)
    (function(){ var t=0, iv=setInterval(function(){ try{ toggleStateVisibility(); }catch(_){ } if(++t>12){ clearInterval(iv);} },150); })();
    $(document).on('change', '#billing_country', toggleStateVisibility);
    setTimeout(toggleStateVisibility, 300);
    
    // Handle address card clicks (not just radio button)
    $(document).on('click', '.saved-address-card', function(e) {
        if ($(e.target).hasClass('edit-saved-address') || $(e.target).closest('.edit-saved-address').length) {
            return; // Don't select when clicking edit button
        }
        
        var $radio = $(this).find('input[type="radio"]');
        $radio.prop('checked', true).trigger('change');
    });
    
    // Handle edit address button - Open checkout modal
    $(document).on('click', '.edit-saved-address', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var addressId = $(this).data('address-id');
        
        // Open checkout address modal for editing
        if ($('#checkout-address-modal').length) {
        openCheckoutAddressModal(addressId);
        } else {
            // Fallback: öffne Adressverwaltung, falls Modal nicht vorhanden
            if (typeof vitalshop_smart_checkout !== 'undefined' && vitalshop_smart_checkout.manage_addresses_url) {
                window.location.href = vitalshop_smart_checkout.manage_addresses_url;
            }
        }
    });
    
    // Handle new address selection - Open checkout modal
    $(document).on('change', 'input[name="selected_address"][value="new"]', function() {
        if ($(this).is(':checked')) {
            openCheckoutAddressModal();
        }
    });
    
    // Handle manage addresses button - Still redirect for full management
    $(document).on('click', '.manage-addresses', function(e) {
        e.preventDefault();
        window.open(vitalshop_smart_checkout.manage_addresses_url, '_blank');
    });
    
    // Load saved address data
    function loadSavedAddress(addressId) {
        
        // Show loading state
        showLoadingState();
        
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'select_checkout_address',
                nonce: vitalshop_smart_checkout.nonce,
                address_id: addressId
            },
            success: function(response) {
                hideLoadingState();
                
                if (response.success) {
                    var addressData = response.data.address_data;
                    
                    if (addressData) {
                        // Fill billing fields with saved address data (One Address System)
                        fillBillingFields(addressData);
        // DEBUG: ✅ Address data loaded and filled;
                        
                        // Load initial VAT table with the correct address data
                        loadInitialVatTable();
                    } else {
                        
                        // Load initial VAT table with default values
                        loadInitialVatTable();
                    }
                } else {
                    showError((vitalshop_smart_checkout && vitalshop_smart_checkout.strings && vitalshop_smart_checkout.strings.error) ? vitalshop_smart_checkout.strings.error : (window.vs_i18n && vs_i18n.error ? vs_i18n.error : 'Fehler'));
                }
            },
            error: function(xhr, status, error) {
                hideLoadingState();
                showError((vitalshop_smart_checkout && vitalshop_smart_checkout.strings && vitalshop_smart_checkout.strings.error) ? vitalshop_smart_checkout.strings.error : (window.vs_i18n && vs_i18n.error ? vs_i18n.error : 'Fehler'));
            }
        });
    }
    
    // Fill billing fields with address data (One Address System)
    function fillBillingFields(addressData) {
        // Map database fields to WooCommerce billing fields
        var fieldMapping = {
            'first_name': 'billing_first_name',
            'last_name': 'billing_last_name',
            'company': 'billing_company',
            'address_1': 'billing_address_1',
            'address_2': 'billing_address_2',
            'city': 'billing_city',
            'postcode': 'billing_postcode',
            'state': 'billing_state',
            'country': 'billing_country',
            'phone': 'billing_phone',
            'email': 'billing_email'
        };
        
        // Always fill email with current user email if logged in
        if (vitalshop_smart_checkout.current_user_email) {
            addressData.email = vitalshop_smart_checkout.current_user_email;
        }
        
        // Fill all mapped fields
        Object.keys(fieldMapping).forEach(function(dbField) {
            var wcField = fieldMapping[dbField];
            var $field = $('#' + wcField);
            
            
            if ($field.length && addressData[dbField]) {
                $field.val(addressData[dbField]);
                
                // Trigger change event for select fields
                if ($field.is('select')) {
                    $field.trigger('change');
                }
                
                // Handle floating labels if they exist
                if ($field.val() && $field.closest('.form-field').length) {
                    $field.closest('.form-field').addClass('has-value');
                }
                
            } else if (!$field.length) {
            } else if (!addressData[dbField]) {
            }
        });
        
        // Trigger WooCommerce update
        $('body').trigger('update_checkout');
        
    }
    
    // Clear all billing fields (One Address System)
    function clearBillingFields() {
        var billingFields = [
            'billing_first_name',
		'billing_last_name',
		'billing_company',
		'billing_address_1',
		'billing_address_2',
		'billing_city',
		'billing_postcode',
		'billing_country',
		'billing_state',
		'billing_phone',
		'billing_email'
        ];
        
        billingFields.forEach(function(field) {
            var $field = $('#' + field);
            if ($field.length) {
                $field.val('');
                
                // Remove floating label state
                if ($field.closest('.form-field').length) {
                    $field.closest('.form-field').removeClass('has-value');
                }
            }
        });
        
    }
    
    // Update visual selection of address cards
    function updateAddressCardSelection($selectedRadio) {
        // Remove selection from all cards
        $('.saved-address-card').removeClass('selected');
        
        // Add selection to current card
        $selectedRadio.closest('.saved-address-card').addClass('selected');
    }
    
    // Show loading state
    function showLoadingState() {
        $('.smart-address-selection').addClass('loading');
        
        if (!$('.address-loading').length) {
            $('.saved-addresses-grid').append(
                '<div class="address-loading">' +
                '<div class="loading-spinner"></div>' +
                '<span>' + vitalshop_smart_checkout.strings.loading + '</span>' +
                '</div>'
            );
        }
    }
    
    // Hide loading state
    function hideLoadingState() {
        $('.smart-address-selection').removeClass('loading');
        $('.address-loading').remove();
    }
    
    // Show error message
    function showError(message) {
        // Remove existing error
        $('.address-error').remove();
        
        // Add error message
        $('.smart-address-selection').prepend(
            '<div class="address-error">' +
            '<span class="error-icon">⚠️</span>' +
            '<span>' + message + '</span>' +
            '</div>'
        );
        
        // Auto-hide after 5 seconds
        setTimeout(function() {
            $('.address-error').fadeOut();
        }, 5000);
    }
    
    // Initialize default address selection on page load
    function initializeDefaultSelection() {
        var $defaultRadio = $('input[name="selected_address"]:checked');
        if ($defaultRadio.length) {
            updateAddressCardSelection($defaultRadio);
            
            // If it's not "new", load the address data
            if ($defaultRadio.val() !== 'new') {
                loadSavedAddress($defaultRadio.val());
            } else {
                // For "new" address, load VAT table with current form data
                loadInitialVatTable();
            }
        }
    }
    
    // Initialize on page load
    initializeDefaultSelection();
    
    /**
     * Load initial VAT table on page load
     */
    function loadInitialVatTable() {
        // Get the current country from the customer data
        var currentCountry = $('select[name="billing_country"], input[name="billing_country"]').val() || 'DE';
        var currentPostcode = $('input[name="billing_postcode"]').val() || '';
        
        
        // Make AJAX call to get VAT table HTML
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'force_wc_session_update',
                nonce: vitalshop_smart_checkout.nonce,
                country: currentCountry,
                first_name: $('input[name="billing_first_name"]').val() || '',
                last_name: $('input[name="billing_last_name"]').val() || '',
                company: $('input[name="billing_company"]').val() || '',
                address_1: $('input[name="billing_address_1"]').val() || '',
                address_2: $('input[name="billing_address_2"]').val() || '',
                city: $('input[name="billing_city"]').val() || '',
                postcode: currentPostcode,
                state: $('select[name="billing_state"], input[name="billing_state"]').val() || '',
                phone: $('input[name="billing_phone"]').val() || '',
                email: vitalshop_smart_checkout.current_user_email
            },
            success: function(response) {
                if (response.success && response.data.vat_table_html) {
        // DEBUG: ✅ Initial VAT table loaded successfully;
                    
                    // Remove any existing VAT tables first
                    $('.vitalshop-modern-order-review .vpe-vat-summary').remove();
                    
                    // Add VAT table after order total
                    var $orderTotalRow = $('.vitalshop-modern-order-review .total-row.order-total-row');
                    if ($orderTotalRow.length > 0) {
                        $orderTotalRow.after(response.data.vat_table_html);
                    }
                } else {
                }
            },
            error: function(xhr, status, error) {
            }
        });
    }
    
    // Handle checkout form submission
    $(document).on('submit', 'form.checkout', function() {
        var selectedAddressId = $('#selected_address_id').val();
    });
    
    // Add custom CSS for loading and error states
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            .address-loading {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
                padding: 20px;
                background: #f8f9fa;
                border-radius: 8px;
                border: 2px dashed #dee2e6;
                color: #6c757d;
                font-size: 14px;
            }
            
            .loading-spinner {
                width: 20px;
                height: 20px;
                border: 2px solid #dee2e6;
                border-top: 2px solid #007cba;
                border-radius: 50%;
                animation: spin 1s linear infinite;
            }
            
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            
            .address-error {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px 16px;
                background: #f8d7da;
                border: 1px solid #f5c6cb;
                border-radius: 6px;
                color: #721c24;
                font-size: 14px;
                margin-bottom: 16px;
            }
            
            .error-icon {
                font-size: 16px;
            }
            
            .smart-address-selection.loading {
                opacity: 0.7;
                pointer-events: none;
            }
        `)
        .appendTo('head');
    
        // DEBUG: ✅ Smart Checkout fully initialized;
    
    // ====== CHECKOUT ADDRESS MODAL FUNCTIONS ======
    
    /**
     * Open checkout address modal for adding/editing
     */
    function openCheckoutAddressModal(addressId) {
        if (typeof addressId === 'undefined') { addressId = null; }
        var $modal = $('#checkout-address-modal');
        var $form = $('#checkout-address-form');
        var $title = $modal.find('.modal-title');
        
        // Reset form safely
        if ($form.length && $form[0].reset) {
            $form[0].reset();
        }
        $('#checkout_address_id').val('');
        
        if (addressId) {
            // Editing existing address
            $title.text(t('edit_address','Adresse bearbeiten'));
            loadAddressForEditing(addressId);
        } else {
            // Adding new address
            $title.text(t('add_address','Adresse hinzufügen'));
        }
        
        // Show modal
        $modal.fadeIn(300);
        $('body').addClass('modal-open');
        
    }
    
    /**
     * Close checkout address modal
     */
    function closeCheckoutAddressModal() {
        var $modal = $('#checkout-address-modal');
        
        $modal.fadeOut(300);
        $('body').removeClass('modal-open');
        
        // DEBUG: ❌ Checkout address modal closed;
    }
    
    /**
     * Load address data for editing in checkout modal
     */
    function loadAddressForEditing(addressId) {
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'get_checkout_address',
                nonce: vitalshop_smart_checkout.nonce,
                address_id: addressId
            },
            success: function(response) {
                if (response.success && response.data.address) {
                    var address = response.data.address;
                    
                    // Fill form fields
                    $('#checkout_address_id').val(address.id);
                    $('#checkout_address_label').val(address.label);
                    $('#checkout_address_first_name').val(address.first_name);
                    $('#checkout_address_last_name').val(address.last_name);
                    $('#checkout_address_company').val(address.company);
                    $('#checkout_address_1').val(address.address_1);
                    $('#checkout_address_2').val(address.address_2);
                    $('#checkout_address_country').val(address.country);
                    $('#checkout_address_postcode').val(address.postcode);
                    $('#checkout_address_city').val(address.city);
                    $('#checkout_address_state').val(address.state);
                    $('#checkout_address_phone').val(address.phone);
                    $('#checkout_address_is_default').prop('checked', address.is_default == '1');
                    
                } else {
                }
            },
            error: function() {
            }
        });
    }
    
    // Modal event handlers
    $(document).on('click', '#checkout-address-modal .modal-close, #checkout-address-modal .modal-cancel', function() {
        closeCheckoutAddressModal();
    });
    
    $(document).on('click', '#checkout-address-modal .modal-overlay', function() {
        closeCheckoutAddressModal();
    });
    
    // Handle checkout address form submission
    $(document).on('submit', '#checkout-address-form', function(e) {
        e.preventDefault();
        
        var $form = $(this);
        var $saveBtn = $form.find('.modal-save');
        var $btnText = $saveBtn.find('.btn-text');
        var $btnLoading = $saveBtn.find('.btn-loading');
        
        // Show loading state
        $btnText.hide();
        $btnLoading.show();
        $saveBtn.prop('disabled', true);
        
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: $form.serialize() + '&action=save_checkout_address&nonce=' + vitalshop_smart_checkout.nonce,
            success: function(response) {
                if (response.success) {
        // DEBUG: ✅ Address saved successfully;
                    
                    // Close modal
                    closeCheckoutAddressModal();
                    
                    // Reload the page to show updated addresses
                    location.reload();
                } else {
                    alert(t('save_address_error','Fehler beim Speichern der Adresse') + ': ' + (response.data || t('unknown_error','Unbekannter Fehler')));
                }
            },
            error: function() {
                alert(t('save_address_error','Fehler beim Speichern der Adresse'));
            },
            complete: function() {
                // Reset button state
                $btnText.show();
                $btnLoading.hide();
                $saveBtn.prop('disabled', false);
            }
        });
    });
    
    // ====== DYNAMIC ORDER REVIEW UPDATE ======
    
    /**
     * Trigger order review update when address changes
     */
    function triggerOrderReviewUpdate(addressId) {
        
        // Get the selected address data first
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'get_checkout_address',
                nonce: vitalshop_smart_checkout.nonce,
                address_id: addressId
            },
            success: function(response) {
                if (response.success && response.data.address) {
                    var address = response.data.address;
                    
                    // Update WooCommerce customer data for shipping calculation
                    updateCustomerShippingData(address);
                } else { }
            },
            error: function(xhr, status, error) { }
        });
    }
    
    /**
     * Update customer shipping data and trigger checkout update
     */
    function updateCustomerShippingData(address) {
        
        // Show loading state on order review
        var $orderReview = $('.woocommerce-checkout-review-order');
        $orderReview.addClass('updating');
        
        // Update shipping fields in the checkout form (for WooCommerce processing)
        $('#billing_country').val(address.country);
        $('#billing_first_name').val(address.first_name);
        $('#billing_last_name').val(address.last_name);
        $('#billing_company').val(address.company || '');
        $('#billing_address_1').val(address.address_1);
        $('#billing_address_2').val(address.address_2 || '');
        $('#billing_city').val(address.city);
        $('#billing_postcode').val(address.postcode);
        $('#billing_state').val(address.state || '');
        $('#billing_phone').val(address.phone || '');
        
        
        // CRITICAL: Force WooCommerce to recognize the field changes by triggering change events
        // This is essential for shipping cost recalculation
        
        // Clear WooCommerce's internal caches first
        if (typeof wc_checkout_params !== 'undefined') {
        }
        
        // Trigger change events with more emphasis
        $('#billing_country').val(address.country).trigger('change').trigger('blur');
        $('#billing_postcode').val(address.postcode).trigger('change').trigger('blur');
        $('#billing_state').val(address.state || '').trigger('change').trigger('blur');
        
        // Also trigger on any shipping fields that might exist (hidden)
        $('#shipping_country').val(address.country).trigger('change');
        $('#shipping_postcode').val(address.postcode).trigger('change');
        $('#shipping_state').val(address.state || '').trigger('change');
        
        // Log current shipping costs before update
        var $currentShipping = $('.vitalshop-modern-order-review .shipping-row');
        $currentShipping.each(function(i, row) {
        });
        
        // CRITICAL: Force WooCommerce backend session update via AJAX
        // This directly updates WooCommerce's PHP session data
        // DEBUG: 🚀 Forcing WooCommerce backend session update...;
        $.ajax({
            url: vitalshop_smart_checkout.ajax_url,
            type: 'POST',
            data: {
                action: 'force_wc_session_update',
                nonce: vitalshop_smart_checkout.nonce,
                country: address.country,
                first_name: address.first_name,
                last_name: address.last_name,
                company: address.company || '',
                address_1: address.address_1,
                address_2: address.address_2 || '',
                city: address.city,
                postcode: address.postcode,
                state: address.state || '',
                phone: address.phone || '',
                email: vitalshop_smart_checkout.current_user_email
            },
            success: function(response) {
                if (response.success) {
        // DEBUG: ✅ WooCommerce backend session updated:;
                    
                    // CRITICAL: Manually update shipping display with backend data
                    var backendShippingTotal = response.data.shipping_total;
                    var shippingProvider = response.data.shipping_provider || 'DHL';
                    
                    // Update shipping provider label
                    var $shippingLabel = $('.vitalshop-modern-order-review .shipping-row .total-label');
                    
                    $shippingLabel.each(function() {
                        var $el = $(this);
                        var currentText = $el.text().trim();
                        var newLabel = 'Lieferung per ' + shippingProvider;
                        
                        // Preserve "kostenfrei" text if it exists
                        if (currentText.includes('kostenfrei')) {
                            newLabel += ' kostenfrei';
                        }
                        
                        $el.html(newLabel + (currentText.includes('kostenfrei') ? ' <span class="shipping-free-text">kostenfrei</span>' : ''));
                    });
                    
                    // Update shipping price
                    var $shippingValue = $('.vitalshop-modern-order-review .shipping-row .shipping-value');
                    
                    $shippingValue.each(function() {
                        var $el = $(this);
                        var currentText = $el.text().trim();
                        
                        // Fix price format: 12.9 -> 12,90 €
                        var formattedPrice = parseFloat(backendShippingTotal).toFixed(2).replace('.', ',') + ' €';
                        
                        $el.html(formattedPrice);
                    });
                    
                    // Also try to update any .woocommerce-Price-amount inside shipping row
                    $('.vitalshop-modern-order-review .shipping-row .woocommerce-Price-amount').each(function() {
                        var $el = $(this);
                        var currentText = $el.text().trim();
                        var formattedPrice = parseFloat(backendShippingTotal).toFixed(2).replace('.', ',') + ' €';
                        $el.html('<bdi>' + formattedPrice + '</bdi>');
                    });
                    
                    // Update tax totals if provided
                    if (response.data.tax_total) {
                        var formattedTaxTotal = parseFloat(response.data.tax_total).toFixed(2).replace('.', ',') + ' €';
                        
                        // Update tax display elements with correct selectors from review-order.php
                        $('.vitalshop-modern-order-review .total-row.tax-row .total-value.tax-value').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(formattedTaxTotal);
                        });
                        
                        // Also update any WooCommerce price amounts in tax rows
                        $('.vitalshop-modern-order-review .total-row.tax-row .woocommerce-Price-amount').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html('<bdi>' + formattedTaxTotal + '</bdi>');
                        });
                    }
                    
                    // Update subtotal if provided
                    if (response.data.subtotal) {
                        var formattedSubtotal = parseFloat(response.data.subtotal).toFixed(2).replace('.', ',') + ' €';
                        
                        // Update subtotal with correct selector from review-order.php
                        $('.vitalshop-modern-order-review .total-row.subtotal-row .total-value').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(formattedSubtotal);
                        });
                    }
                    
                    // Update cart total if provided
                    if (response.data.cart_total) {
                        
                        // Update main total with correct selector from review-order.php
                        $('.vitalshop-modern-order-review .total-row.order-total-row .total-value.total-value-main').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(response.data.cart_total);
                        });
                        
                        // Fallback: Also try the old selector in case structure changes
                        $('.vitalshop-modern-order-review .total-sum .woocommerce-Price-amount').each(function() {
                            var $el = $(this);
                            var currentText = $el.html();
                            $el.html(response.data.cart_total);
                        });
                    }
                    
                    // Update VPE VAT table if provided
                    if (response.data.vat_table_html) {
                        
                        // Remove ALL existing VAT tables first
                        $('.vitalshop-modern-order-review .vpe-vat-summary').remove();
                        
                        
                        // Add the new VAT table
                        var $orderTotalRow = $('.vitalshop-modern-order-review .total-row.order-total-row');
                        if ($orderTotalRow.length > 0) {
                            $orderTotalRow.after(response.data.vat_table_html);
                        }
                    }
                    
                    // Now trigger WooCommerce checkout update to refresh all elements including VAT table
                    setTimeout(function() {
                        $('body').trigger('update_checkout');
                    }, 100);
                } else {
                    // Fallback to frontend-only update
                    setTimeout(function() {
                        $('body').trigger('update_checkout');
                    }, 500);
                }
            },
            error: function(xhr, status, error) {
                // Fallback to frontend-only update
                setTimeout(function() {
                    $('body').trigger('update_checkout');
                }, 500);
            }
        });
        
        // Backup timeout in case updated_checkout event doesn't fire (due to JS errors)
        setTimeout(function() {
            if ($orderReview.hasClass('updating')) {
                $orderReview.removeClass('updating');
            }
        }, 10000); // 10 second timeout
        
        // Listen for checkout update completion
        $(document.body).one('updated_checkout', function() {
            $orderReview.removeClass('updating');
        // DEBUG: ✅ Order review updated successfully;
            
            // Force refresh of shipping display if needed
            setTimeout(function() {
                
                // Debug: Check what order review containers exist
                $('.woocommerce-checkout-review-order').each(function(i, el) {
                });
                
                // Try multiple selectors
                var selectors = [
                    '.vitalshop-modern-order-review .shipping-row',
                    '.woocommerce-checkout-review-order .shipping-row', 
                    '.shipping-row',
                    '.total-row.shipping-row',
                    '[class*="shipping"]'
                ];
                
                selectors.forEach(function(selector) {
                    var $elements = $(selector);
                    if ($elements.length > 0) {
                        $elements.each(function(i, el) {
                        });
                    }
                });
                
                // Check if order review HTML changed completely
                var orderReviewHTML = $('.woocommerce-checkout-review-order').html();
                if (orderReviewHTML) {
                    
                    // Show first 500 chars of HTML to see what template is being used
                }
            }, 100);
            
            // Optional: Show a brief success indicator
            showOrderUpdateSuccess();
        });
    }
    
    /**
     * Show brief success indicator for order update
     */
    function showOrderUpdateSuccess() {
        var msg = (window.vitalshop_smart_checkout && vitalshop_smart_checkout.strings && vitalshop_smart_checkout.strings.shipping_updated)
            ? vitalshop_smart_checkout.strings.shipping_updated
            : '✅ Versandkosten aktualisiert';
        var $indicator = $('<div class="order-update-success"></div>').text(msg);
        $indicator.css({
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: '#28a745',
            color: 'white',
            padding: '12px 20px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            zIndex: '10000',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            opacity: '0',
            transform: 'translateY(-20px)'
        });
        
        $('body').append($indicator);
        
        // Animate in
        $indicator.animate({
            opacity: 1,
            transform: 'translateY(0)'
        }, 300);
        
        // Auto remove after 3 seconds
        setTimeout(function() {
            $indicator.animate({
                opacity: 0,
                transform: 'translateY(-20px)'
            }, 300, function() {
                $indicator.remove();
            });
        }, 3000);
    }
    
});